module.exports = __webpack_public_path__ + "static/cube12-b400a8d98c8269b759769dbb5b7842b8.svg";